import { get, patch, post, del } from './requests'

const baseUrl = 'areas-of-activity'

export const getAreasOfActivityService = (key, id) =>
  get([baseUrl, id], { key, transformPayload: true })

export const getAreaOfActivityMetaService = key =>
  get([baseUrl, 'meta'], { key, transformPayload: true })

export const getAreasOfActivityListService = key =>
  get([baseUrl], {
    key,
    transformPayload: true,
  })

export const getAreaOfActivityByIdService = (key, id) =>
  get([baseUrl, id], { key, transformPayload: true })

export const postAreaOfActivityService = (key, payload) =>
  post([baseUrl], { key, transformPayload: true }, payload)

export const patchAreaOfActivityService = (key, id, payload) =>
  patch([baseUrl, id], { key, transformPayload: true }, payload)

export const deleteAreaOfActivityService = (key, id) =>
  del([baseUrl, id], { key, transformPayload: true })
